<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Rider Attachment Orders</h1>
            <hr>
            <mdb-row>
                <mdb-col md="3">
                    <div class="form-group">
                        <mdb-date-picker :autoHide="true" v-model="from" label="Date From" />
                    </div>
                </mdb-col>
                <mdb-col md="3">
                    <div class="form-group">
                        <mdb-date-picker :autoHide="true"  v-model="to" label="Date To" />
                    </div>
                </mdb-col>
                <mdb-col md="6">
                    <mdb-btn @click="getData()" v-if="!loading" outline="primary"><mdb-icon icon="search" /> Search</mdb-btn>
                    <mdb-spinner small v-if="loading" />
                </mdb-col>
            </mdb-row>
            <mdb-row class="mb-3">
                <mdb-col col="4" class="d-flex flex-center text-warning py-3" style="border: 1px solid #ffbb33">
                    Pending Upload: <strong>{{this.pending_upload}}</strong>
                </mdb-col>
                <mdb-col col="4" class="d-flex flex-center purple-text py-3" style="border: 1px solid #9c27b0">
                    Pending Approve: <strong>{{this.pending_approve}}</strong>
                </mdb-col>
                <mdb-col col="4" class="d-flex flex-center text-success py-3" style="border: 1px solid #00C851">
                    Completed: <strong>{{this.completed}}</strong>
                </mdb-col>
            </mdb-row>
            <mdb-tbl responsive striped>
                <mdb-tbl-head>
                <tr>
                    <th width="5%">#</th>
                    <th>Order No.</th>
                    <th>Merchant/Rider</th>
                    <th>Bill Charge</th>
                    <th>Date Time</th>
                    <th>Action</th>
                </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                <tr v-for="(order, index) in orders" :key="order.id"  style="cursor: pointer">
                    <th scope="row">{{index+1}}</th>
                    <td>
                        <div @click.prevent.stop class="order-number-text">{{order.order_number}}</div>
                        <div v-if="order.service_id==1 && order.merchant.zone" :style="{'color': order.merchant.zone.color}">{{order.merchant.zone.name}}</div>
                        <div v-if="order.service_id==1" class="small">Food Delivery</div>
                        <div v-if="order.service_id==2" class="small">Virtual Merchant</div>
                        <div class="d-flex flex-row">
                            <div v-if="order.service_id==1 && order.merchant.is_pb==1" class="pb-remark small">PB</div>
                            <div v-if="order.service_id==1 && order.merchant.is_mart==1" class="mart-remark small">Mart</div>
                            <div v-if="order.comment_admin" class="note-remark small">Note</div>
                        </div>
                    </td>
                    <td>
                        <div @click.prevent.stop class="order-number-text" @click="navigateToMerchantList(order.merchant.name)" v-if="order.service_id==1">{{order.merchant.name}}</div>
                        <hr />
                        <div>[ {{order.partner_user.partner_profile.partner_code}} ] - {{order.partner_user.partner_profile.fullname}}</div>
                    </td>
                    <td>
                        <div v-if="order.pb_amount!=0" class="font-weight-bold text-info">PB Amount: RM {{order.pb_amount}}</div>
                        <div style="color: #3f51b5;" class="font-weight-bold" v-if="order.pb_amount!=0 && order.pb_user_id!=0">RIDER PAID</div>
                        <div style="color: #f0bb1b;" class="font-weight-bold" v-if="order.pb_amount!=0 && order.pb_user_id==0">LAPAR PAID</div>
                        <hr v-if="order.pb_amount!=0" />
                        <div style="text-decoration: line-through;" v-if="order.service_charge.subtotal != order.service_charge.grand_total">RM {{order.service_charge.subtotal}}</div>
                        <div class="d-flex flex-row">
                            <mdb-tooltip v-if="order.service_charge.payment_type=='EWALLET_TNG'" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">EGHL TnG</span>
                                <a slot="reference">
                                <img :src="require('@/assets/tng.png')" style="height: 20px; width: 20px" />
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="order.service_charge.payment_type=='ONLINE_BANKING'" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Online Banking</span>
                                <a slot="reference">
                                <img :src="require('@/assets/online_banking.png')" style="height: 20px; width: 20px" />
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="order.service_charge.payment_type=='CASH'" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Cash</span>
                                <a slot="reference">
                                    <img :src="require('@/assets/cash.png')" style="height: 20px; width: 20px" />
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="order.service_charge.payment_type=='CREDIT_DEBIT_CARD'" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Card</span>
                                <a slot="reference">
                                    <img :src="require('@/assets/card.png')" style="height: 20px; width: 20px" />
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="order.service_charge.payment_type=='EWALLET'" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">E-Wallet</span>
                                <a slot="reference">
                                    <img :src="require('@/assets/e_wallet.png')" style="height: 20px; width: 20px" />
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="order.service_charge.payment_type=='TNG'" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Touch and Go eWallet</span>
                                <a slot="reference">
                                    <img :src="require('@/assets/tng.png')" style="height: 20px; width: 20px" />
                                </a>
                            </mdb-tooltip>
                            <div class="ml-2">RM {{order.service_charge.grand_total}}</div>
                        </div>
                    </td>
                    <td>
                        <div>{{momentFormat16(order.created_at)}}</div>
                        <div class="text-success">{{momentFormat(order.time_complete)}}</div>
                        <div class="text-danger">{{momentFormat(order.time_cancel_job)}}</div>
                    </td>
                    <td class="d-flex flex-column">
                        <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                            <span slot="tip">Show Order Detail</span>
                            <a slot="reference">
                                <mdb-btn @click="showOrderDetail(order.id)" color="primary" size="sm"><mdb-icon far icon="eye" class="mr-1"/> Order Detail</mdb-btn>
                            </a>
                        </mdb-tooltip>
                        <mdb-tooltip v-if="order.service_order_partner_attachments.length!=0 && order.pb_amount==0" trigger="hover" :options="{placement: 'top'}">
                            <span slot="tip">Show Order Attachments</span>
                            <a slot="reference">
                                <mdb-btn @click="showOrderAttachments(order)" color="secondary" size="sm"><mdb-icon far icon="eye" class="mr-1"/> RM {{parseFloat(order.total_pb_amount).toFixed(2)}}</mdb-btn>
                            </a>
                        </mdb-tooltip>
                        <mdb-tooltip v-if="order.service_order_partner_attachments.length!=0 && order.pb_amount!=0" trigger="hover" :options="{placement: 'top'}">
                            <span slot="tip">Show Order Attachments</span>
                            <a slot="reference">
                                <mdb-btn @click="showOrderAttachments(order)" color="success" size="sm"><mdb-icon icon="check" class="mr-1"/> RM {{parseFloat(order.total_pb_amount).toFixed(2)}}</mdb-btn>
                            </a>
                        </mdb-tooltip>
                    </td>
                </tr>
                </mdb-tbl-body>
            </mdb-tbl>
            <OrderDetailComponent :id="focus_order_id" :visible="order_detail_component" :close="closeOrderDetailComponent" :callback="getData" />
            <OrderPartnerAttachments :order="focus_order" :visible="show_order_attachments" :close="closeOrderDetailComponent" :callback="getData"/>
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbTbl, mdbTblHead, mdbTblBody, mdbBtn, mdbIcon,
mdbTooltip, mdbDatePicker, mdbRow, mdbCol, mdbSpinner } from 'mdbvue';
import moment from 'moment';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import {checkPermissionsBinary} from '../js/helper';
import OrderDetailComponent from '../components/OrderDetailComponent';
import OrderPartnerAttachments from '../components/OrderPartnerAttachments';

export default {
  name: 'partner_online',
  components: {
    mdbContainer, mdbDatePicker,
    AppNavigation, mdbTbl, mdbTblHead, mdbTblBody, OrderPartnerAttachments,
    mdbTooltip, OrderDetailComponent, mdbBtn, mdbIcon, mdbRow, mdbCol, mdbSpinner
  },
  data: ()=>({
      orders: [],
      loading: false,
      focus_order_id: 0,
      order_detail_component: false,
      focus_order: null,
      show_order_attachments: false,
      from: "",
      to: "",
      pending_approve: 0,
      pending_upload: 0,
      completed: 0
  }),
  methods: {
        getData(){
        if(!checkPermissionsBinary(67, this.$store.state.permissions)){
            this.$notify.error({message: "Access Denied.", position: 'top right', timeOut: 5000})
            return false;
        }
        if(this.loading){
            return false;
        }
        this.loading=true;
        ajax({
            url: "admin/get_pb_orders",
            data: {
                from: this.from,
                to: this.to
            },
            complete: ()=>this.loading=false,
            success: result=>{
                this.completed=0;
                this.pending_approve=0;
                this.pending_upload=0;
                result.data.forEach(element => {
                    let pb_amount=0;
                    element.service_order_partner_attachments.forEach(partner_pb => {
                        pb_amount+=parseFloat(partner_pb.amount);
                    });
                    element.total_pb_amount=pb_amount;
                    if(element.pb_amount>0){
                        this.completed=this.completed+1;
                    }else if(element.service_order_partner_attachments.length>0){
                        this.pending_approve=this.pending_approve+1;
                    }else{
                        this.pending_upload=this.pending_upload+1;
                    }
                });
                this.orders=result.data;
            },
        }, this)
        },
        closeOrderDetailComponent(){
            this.order_detail_component=false;
            this.show_order_attachments=false;
        },
        momentFormat16(date){
            if(date){
                return moment(date, "YYYY-MM-DD h:mm:ss").utcOffset('+16:00').format('DD/MM/YYYY h:mm a');
            }
            return "";
        },
        momentFormat(date){
            if(date){
                return moment(date, "YYYY-MM-DD h:mm:ss").format('DD/MM/YYYY h:mm a');
            }
            return "";
        },
        showOrderDetail(id){
            this.focus_order_id=id;
            this.order_detail_component=true;
        },
        permissionCheck(permission){
            return checkPermissionsBinary(permission, this.$store.state.permissions);
        },
        navigateToMerchantList(name){
            if(checkPermissionsBinary(20, this.$store.state.permissions)){
                this.$router.push({ name: 'merchant_list', params: {name: name}});
            }
        },
        showOrderAttachments(order){
            this.show_order_attachments=true;
            this.focus_order=order;
        }
  },
  mounted: function(){
    if(checkPermissionsBinary(67, this.$store.state.permissions)){
        let date = new Date();
        let month = date.getMonth()+1;
        this.from=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
        this.to=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
        this.getData();
    }
  }
}
</script>

<style scoped>
.status-cancelled{
    border: 1.5px solid #ff4444;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ff4444;
}
.status-completed{
    border: 1.5px solid #00C851;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #00C851;
}
.status-new{
    border: 1.5px solid #4285F4;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4285F4;
}
#copy-text{
    position: absolute;
    top: -9999999999px;
    left: -9999999999px;
}
.order-number-text:hover{
    color: #4285F4;
    font-weight: bold;
}
.order-number-text{
    font-weight: bold;
}
.pb-remark{
    background-color: #E91E63;
    color: #fff;
    width: 30px;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 10px;
    margin: 0px 5px 0px 00px;
}
.mart-remark{
    background-color: #4caf50;
    color: #fff;
    width: 50px;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 30px;
    margin: 0px 5px 0px 00px;
}
.note-remark{
    background-color: #ffeb3b;
    color: #000;
    width: 50px;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 30px;
    margin: 0px 5px 0px 00px;
}
</style>